import type { RecurringRevenueReport } from '@vy/types';
import { vyDate } from '@vy/utils';

// Pure helpers extracted so worker code (which can't depend on React/MUI)
// can reach them without pulling in `RecurringRevenueReportTableColumns.tsx`.

const MONTH_COLUMN_PATTERN = /^[A-Za-z]{3} \d{4}$/;

export function extractMonthlyColumnKeys(rows: RecurringRevenueReport): string[] {
  if (rows.length === 0) {
    return [];
  }

  const monthKeys = new Set<string>();

  for (const row of rows) {
    for (const key of Object.keys(row)) {
      if (MONTH_COLUMN_PATTERN.test(key)) {
        monthKeys.add(key);
      }
    }
  }

  return Array.from(monthKeys).sort(sortMonthsChronologically);
}

export function isMonthColumnKey(key: string): boolean {
  return MONTH_COLUMN_PATTERN.test(key);
}

function sortMonthsChronologically(firstMonthKey: string, secondMonthKey: string): number {
  // `keepLocalTime: true` so the strings are parsed as UTC wall-clock months;
  // see `month-key-utils.ts` for full rationale.
  const firstMonth = vyDate(firstMonthKey, { format: 'MMM YYYY', keepLocalTime: true });
  const secondMonth = vyDate(secondMonthKey, { format: 'MMM YYYY', keepLocalTime: true });

  if (firstMonth.isBefore(secondMonth)) return -1;
  if (firstMonth.isAfter(secondMonth)) return 1;
  return 0;
}
